import React from 'react'
import PropTypes from 'prop-types'
import { Typography } from '@material-ui/core'
import FlexRow from '../../molecules/FlexRow'
import Loading from '../../molecules/Loading'
import { useArtifact } from './ArtifactProvider'
import { detectStrategy, getDisplayStrategy } from './displays/displayStrategyRegistry'

function ArtifactDisplay ({ strategy = 'debug', placeholder = 'No report selected' }) {
  const { selectedArtifactId, selectedArtifact, isLoading, error } = useArtifact()

  if (!selectedArtifactId) {
    return (
      <FlexRow className='justify-center items-center p-md'>
        <Typography color='textSecondary'>
          {placeholder}
        </Typography>
      </FlexRow>
    )
  }

  if (isLoading) {
    return <Loading />
  }

  if (error) {
    return (
      <FlexRow className='justify-center items-center p-md'>
        <Typography color='error'>
          Failed to load artifact: {error.message || 'Unknown error'}
        </Typography>
      </FlexRow>
    )
  }

  if (!selectedArtifact) {
    return (
      <FlexRow className='justify-center items-center p-md'>
        <Typography color='textSecondary'>
          {placeholder}
        </Typography>
      </FlexRow>
    )
  }

  const resolvedStrategy = strategy === 'auto'
    ? detectStrategy(selectedArtifact)
    : strategy

  const DisplayComponent = getDisplayStrategy(resolvedStrategy)

  return <DisplayComponent artifact={selectedArtifact} />
}

ArtifactDisplay.propTypes = {
  strategy: PropTypes.string,
  placeholder: PropTypes.string
}

export default ArtifactDisplay
